<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup AirTable</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    @if (isCopyConfigurationButtonVisible) {
      <blaze-copy-connector-config-env-button
        [coupledConnector]="coupledConnector$ | async"
        (copyConfiguration)="copyConfiguration($event)"
      />
    }
    @if (!!template?.id) {
      <button
        [disabled]="connectorForm.invalid || isLoading"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        create connector
      </button>
    }
    @if (!!connector?.id) {
      <button
        [disabled]="connectorForm.invalid || isLoading"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        update connector
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    <form class="form" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Name Your Connector</label>
        <input
          formControlName="connectorName"
          name="connectorName"
          class="bd-text-input tall w-full"
          required
        />
      </div>

      <h3 class="text-13 font-medium mb-16">General</h3>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">
          <span>Personal Access Token</span>
          <a
            href="https://support.airtable.com/docs/creating-personal-access-tokens"
            class="hint"
            target="_blank"
            rel="noopener noreferrer"
          >
            <mat-icon svgIcon="icon_info_inverted_16" />
            How to find Airtable Personal Access Token
          </a>
        </label>
        <input formControlName="apiKey" name="apiKey" class="bd-text-input tall w-full" required />
      </div>

      <div class="form-control mb-22">
        <label class="field-label bd-field-label required">Base ID</label>
        <input formControlName="baseId" name="baseId" class="bd-text-input tall w-full" required />
      </div>

      <h3 class="text-13 font-medium mb-16">Table(s)</h3>

      <div class="form-control mb-22" formArrayName="tables">
        <div class="tables">
          <label class="table-name-label field-label bd-field-label required">Table Name</label>
          <label class="table-field-label field-label bd-field-label"
            >Primary Field Name (Optional)</label
          >

          @for (table of tables.controls; track table; let index = $index) {
            <ng-container [formGroupName]="index">
              <div class="table-name-input">
                <input
                  formControlName="name"
                  [name]="'tableName' + index"
                  class="bd-text-input tall w-full"
                />
              </div>
              <div class="table-field-input">
                <input
                  formControlName="primaryFieldName"
                  [name]="'fieldName' + index"
                  class="bd-text-input tall w-full"
                />
              </div>
              <div class="table-actions">
                @if (canRemoveTable) {
                  <button
                    blazeIconButton
                    blazeIconButtonSize="xl"
                    class="action remove"
                    (click)="removeTable(index)"
                    type="button"
                  >
                    <mat-icon svgIcon="icon_trash_24" />
                  </button>
                }
              </div>
            </ng-container>
          }

          <div class="table-summary">
            <button
              blazeButton="secondary"
              class="add-table-btn"
              (click)="addTable()"
              type="button"
              blazeTooltip="Add table"
            >
              <mat-icon svgIcon="icon_add_32" />
              Table
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</blaze-panel>
